// ═══════════════════════════════════════════════════════
//  CONSULTEC FIELD MANAGER — Firebase Configuration
//  Archivo: src/services/firebase.js
//
//  INSTRUCCIONES DE CONFIGURACIÓN:
//  1. Ve a https://console.firebase.google.com
//  2. Crea un proyecto: "consultec-field-manager"
//  3. Habilita: Authentication, Firestore, Storage
//  4. Copia tus credenciales en FIREBASE_CONFIG abajo
//  5. En Firestore, crea colecciones: users, projects,
//     bitacora, incidencias, fases, personal, docs, reportes
// ═══════════════════════════════════════════════════════

// ── REEMPLAZA CON TUS CREDENCIALES DE FIREBASE ──────────
const FIREBASE_CONFIG = {
  apiKey:            "AIzaSyC8O5r2XHWTuF4f3nxQ5-tM6Gj8GKuMxig",
  authDomain:        "consultec-field-manager.firebaseapp.com",
  projectId:         "consultec-field-manager",
  storageBucket:     "consultec-field-manager.appspot.com",
  messagingSenderId: "277363346011",
  appId:             "1:277363346011:web:fdb34229307ba0ce3a0d7e",
  measurementId:     "TU_MEASUREMENT_ID"
}
// ── FIN DE CREDENCIALES ──────────────────────────────────

// Inicialización
let app, auth, db, storage
let firebaseReady = false

export function initFirebase () {
  try {
    // Evitar doble inicialización
    if (firebase.apps.length === 0) {
      app = firebase.initializeApp(FIREBASE_CONFIG)
    } else {
      app = firebase.app()
    }
    auth    = firebase.auth()
    db      = firebase.firestore()
    storage = firebase.storage()

    // Habilitar persistencia offline
    db.enablePersistence({ synchronizeTabs: true })
      .catch(err => {
        if (err.code === 'failed-precondition') {
          console.warn('Persistencia offline: múltiples tabs abiertas')
        } else if (err.code === 'unimplemented') {
          console.warn('Persistencia offline no disponible en este navegador')
        }
      })

    firebaseReady = true
    console.log('✅ Firebase inicializado correctamente')
    return { app, auth, db, storage }
  } catch (error) {
    console.error('❌ Error iniciando Firebase:', error)
    console.warn('⚠️ Modo DEMO activo — datos locales solamente')
    firebaseReady = false
    return null
  }
}

export const getFirebase = () => ({ app, auth, db, storage, ready: firebaseReady })

// ═══════════════════════════════════════════════════════
//  ESTRUCTURA DE BASE DE DATOS — FIRESTORE
//
//  /users/{uid}
//    name, email, role, empresa, proyectos[], createdAt
//
//  /projects/{projectId}
//    nombre, tipo, empresa, cliente, presupuesto,
//    fechaInicio, fechaEntrega, supervisor, status,
//    avanceFisico, avanceFinanciero, createdAt
//
//  /projects/{projectId}/bitacora/{notaId}
//    texto, zona, categoria, autorUid, autorNombre,
//    fotos[], gps{lat,lng}, createdAt
//
//  /projects/{projectId}/incidencias/{incId}
//    titulo, descripcion, severidad, zona, responsable,
//    status, fotos[], autorUid, createdAt, closedAt
//
//  /projects/{projectId}/fases/{faseId}
//    nombre, tipo, responsable, estado, pct,
//    fechaInicio, fechaFin, orden, updatedAt
//
//  /projects/{projectId}/personal/{personaId}
//    nombre, rol, zona, categoria, online, joinedAt
//
//  /projects/{projectId}/docs/{docId}
//    nombre, tipo, url, size, version, autorUid, createdAt
//
//  /projects/{projectId}/estimaciones/{estId}
//    numero, contratista, concepto, monto, periodo,
//    estado, aprobadoPor, createdAt
//
//  /projects/{projectId}/reportes/{repId}
//    tipo, titulo, datos, pdfUrl, firmado,
//    firmantes[], createdAt
// ═══════════════════════════════════════════════════════
